export function digitNumber(str_num) {
    if (isNaN(str_num)) return 0
    if (str_num === 0) {
        str_num = '0'
    }
    let num = [...str_num].reverse().join("");

    let s =''
    if (num.length > 0) {
    s += num[0]
    }
    let k = 1
    let raz = false
    for (let i=1; i<num.length; i++) {
        if (k % 3 === 0) {
            if (num[i] !== ' ') {
            if (raz) {
                s += num[i]
                raz = false
            }
            else {
                s += ' ' + num[i]
            }
            k++
            }
            else {
            s += ' '
            raz = true
            }
        }
        else if (num[i] !== ' ') {
            s += num[i]
            k++
        }
    }
    return [...s].reverse().join('')
}